import { makeStyles } from '@mui/styles';

import Typography from '@classify/react-core-components/Typography';

const useStyles = makeStyles(
  ({ palette, spacing }) => ({
    root: {
      padding: spacing(1, 0, 1, 2),
      margin: 0,
    },
    label: {
      color: palette.text.inactive,
    },
  }),
  { classNamePrefix: 'DrawerMenuLabel' }
);

function DrawerMenuLabel({ label }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.label} variant="overline">
        {label}
      </Typography>
    </div>
  );
}

export default DrawerMenuLabel;
